import { getVal, getFirebase } from 'react-redux-firebase';
import {
  OwnFocusedCardComponentProps,
  StateFocusedCardComponentProps
} from './FocusedCardComponent';
import { BoardCards, Card, StoreState } from '../../../types';

const getRootCard = (
  cardId: string,
  cards: BoardCards,
  visited: string[] = [],
  hasParent: boolean = false
): string | undefined => {
  if (visited.indexOf(cardId) >= 0) {
    return undefined;
  }

  if (cards[cardId].parent) {
    visited.push(cardId);
    if (cardId !== cards[cardId].parent) {
      return getRootCard(cards[cardId].parent as string, cards, visited, true);
    }
  }
  if (hasParent) {
    return cardId;
  }
  return undefined;
};

const getCardsInTheStack = (parentId: string, cards: BoardCards): Card[] => {
  return Object.keys(cards)
    .filter(key => getRootCard(key, cards) === parentId)
    .map(key => Object.assign({}, cards[key], { id: key }));
};

export const mapStateToProps = (
  state: StoreState,
  ownProps: OwnFocusedCardComponentProps
): StateFocusedCardComponentProps => {
  const boardCards: BoardCards = getVal(
    state.fbState,
    `data/${ownProps.boardUrl}/cards`,
    {}
  );

  const cardsInStack = getCardsInTheStack(
    ownProps.focused.id as string,
    boardCards
  );
  cardsInStack.unshift(ownProps.focused);

  const setParentOfCard = (cardId: string, parentId: string | null) => {
    getFirebase()
      .ref(`${ownProps.boardUrl}/cards/${cardId}`)
      .update({
        parent: parentId
      });
  };

  const setRootCard = (index: number) => {
    if (index > 0 && index < cardsInStack.length) {
      const oldRoot = cardsInStack[0];
      const newRoot = cardsInStack[index];

      setParentOfCard(newRoot.id as string, null);
      setParentOfCard(oldRoot.id as string, newRoot.id as string);

      getFirebase()
        .ref(`${ownProps.boardUrl}/config/focusedCardId`)
        .set(newRoot.id)
        .catch((err: Error) => {
          console.error('Could not set focus on card', {
            extra: {
              reason: err.message,
              boardId: ownProps.boardUrl,
              cardId: newRoot.id
            }
          });
        });
    }
  };

  return {
    cards: cardsInStack,
    setRootCard
  };
};
